import styled from 'styled-components'

import { S_ContentColumn } from '../_components/layout/ContentColumn'
import { cssBreakpoints } from '../_constants/styles'

const sectionBorder = '1px solid #d5d5d5'
export const S_ClientHomePage = styled.div`
  ${S_ContentColumn} {
    max-width: 800px;
  }

  .main-content {
    padding: 50px 15px 100px;
    display: flex;
    flex-direction: column;
    max-width: 830px;
    margin: 0 auto;
    width: 100%;

    .flex-header {
      display: flex;
      margin-bottom: 32px;
      .business-name {
        flex-grow: 1;
        font-size: 40px;
      }
    }

    @media screen and (min-width: 820px) {
      grid-template-columns: max-content auto;

      & > button {
        justify-self: right;
      }
    }
  }

  .actions-row {
    margin-top: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    button,
    a {
      padding-left: 20px;
      padding-right: 20px;
      margin-right: 10px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 5px;

      @media screen and (max-width: ${cssBreakpoints.mobileMd}) {
        margin: 5px;
        width: 100%;
        display: block;
      }
    }
    .download-icon {
      margin-right: 5px;
      width: 18px;
      height: 18px;
    }
  }

  section {
    margin-top: 20px;
    border-radius: 5px;

    @media screen and (min-width: 820px) {
      grid-column-start: span 2;
    }

    .section-title {
      padding: 15px 0;
      font-size: 26px;
    }

    .tab-title {
      text-decoration: underline;
      margin-bottom: 1em;
    }
    .section-content {
      padding: 15px;
      border: ${sectionBorder};
      border-radius: 3px;
      &.no-spacing {
        padding: 0;
      }
    }

    .empty-msg {
      text-align: center;
      padding: 30px 15px;
      color: #666;
    }
  }

  .panel-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: center;
    padding: 15px;
    margin-bottom: -10px;
    border-top: ${sectionBorder};

    button {
      margin: 0 5px 10px;
    }
  }
`
